import { Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import MainLayout from "../../layouts/MainLayout";
import { useState } from "react";
import LoginForm from "./Forms/Login";
import "./Login.css";
import RegisterForm from "./Forms/Register";
import { useTranslation } from "react-i18next";

function LoginPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return(
    <MainLayout>
      <section className="auth-section py-5">
        <Container>
          <Row>
            <Col lg="5" md="6" className="mx-auto">
              <div className="text-center">
                <img src={ require('../../assets/images/logo.png') } height={60} alt="Logo" />
              </div>

              <h3 className="text-center mb-3 mt-5 text-primary fw-normal">{ t('auth.title') }</h3>
              <p className="text-center mb-4">
                { t('auth.description') }
              </p>

              <div className="bg-white auth-form-container">
                <Nav tabs justified>
                  <NavItem>
                    <NavLink
                      className={activeTab === "1" ? "active" : ""}
                      onClick={() => { toggleTab("1"); }}
                    >
                      { t('auth.tabs.login.title') }
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "2" ? "active" : ""}
                      onClick={() => { toggleTab("2"); }}
                    >
                      { t('auth.tabs.register.title') }
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent className="px-4 py-5" activeTab={activeTab}>
                  <TabPane tabId="1">
                    <LoginForm />
                  </TabPane>
                  <TabPane tabId="2">
                    <RegisterForm />
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </MainLayout>
  );
}

export default LoginPage;